<template>
  <transition
    enter-from-class="tw-translate-x-full tw-opacity-0"
    enter-active-class="tw-transition tw-duration-300 tw-ease-out"
    leave-to-class="tw-translate-x-full tw-opacity-0"
    leave-active-class="tw-transition tw-duration-300 tw-ease-in"
  >
    <t-slide-out
      v-if="modelValue"
      variant="plain"
      :initial-width="600"
      test-id="spamtitan-connection-slide-out"
      @close="$emit('update:modelValue', false)"
    >
      <template #header>
        <div class="tw-flex tw-items-center">
          <cb-icon-mail-lock
            :width="40"
            color="currentColor"
            class="tw-mr-4 tw-p-2 tw-bg-primary-grey-50 tw-rounded-lg tw-self-start"
          />
          <p class="tw-text-xl tw-font-medium tw-mr-2">
            {{ t("out-title-spamtitan-configuration") }}
          </p>
          <span
            class="tw-text-xs tw-bg-system-warning-100 tw-px-2 tw-py-1 tw-rounded-xl"
            >{{ t("recommended") }}</span
          >
        </div>
      </template>
      <template #body>
        <div class="tw-p-4 tw-bg-primary-grey-25 tw-h-full">
          <div>
            <p class="tw-text-xl tw-font-medium tw-mb-4">
              {{ t("ndr-manual-configuration") }}
            </p>
            <p class="tw-mb-4">
              {{ t("spamtitan-config") }}
            </p>
            <div class="tw-mb-4">
              <div class="tw-flex tw-items-center tw-mb-4">
                <span
                  class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
                  >1</span
                >
                <p>{{ t("disable-link-lock-title") }}</p>
              </div>
              <div
                class="tw-border tw-border-primary-grey-100 tw-rounded-xl tw-p-4"
              >
                <ul class="tw-list-decimal tw-pl-4">
                  <li class="tw-mb-2" v-html="t('log-into-spamtitan')"></li>
                  <li class="tw-mb-2" v-html="t('customer-view')"></li>
                  <li class="tw-mb-2" v-html="t('navigate-to-link-lock')"></li>
                  <li
                    class="tw-mb-2"
                    v-html="t('disable-link-lock-steps')"
                  ></li>
                </ul>
              </div>
            </div>
            <div class="tw-mb-4">
              <div class="tw-flex tw-items-center tw-mb-4">
                <span
                  class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
                  >2</span
                >
                <p>
                  {{ t("step-outbound-connector") }}
                </p>
              </div>
              <div
                class="tw-border tw-border-primary-grey-100 tw-rounded-xl tw-p-4"
              >
                <ul class="tw-list-decimal tw-pl-4">
                  <li class="tw-mb-2">
                    {{ t("spamtitan-outbound-connector") }}
                  </li>
                  <li class="tw-mb-2">
                    {{ t("guide-connector-azure") }}
                    <t-link
                      :is-external="true"
                      href="https://support.titanhq.com/en/index-en.html?contextId=outbound-connector-azure"
                      :string="'documentation guide'"
                      :data-test-id="`spamtitan-leran-more-docs-link`"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </t-slide-out>
  </transition>
</template>

<script setup lang="ts">
import TSlideOut from "@/components/TSlideOut/TSlideOut.vue";
import TLink from "@/components/TLink";
import { useI18n } from "vue-i18n";

interface Props {
  modelValue: boolean;
}

defineProps<Props>();
defineEmits<{ "update:modelValue": [value: boolean] }>();
const { t } = useI18n();
</script>
